import React, { useCallback } from 'react';
import Animated from 'react-native-reanimated';
import { AppView, Button, ButtonGroup, rem, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader, } from 'design-system';
import { HEIGHT } from 'design-system/Button';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import DeleteNeedAssitanceCard from './components/DeleteNeedAssistanceCard';
const strings = {
    deletingYourAccount: 'Deleting your account to create a new one is not advised',
    youMightLoseAccess: 'You might lose access to Emma forever. If you want to reset your editing history, please use your existing account',
    deleteAnyway: 'Delete anyway',
    takeMeBack: 'Take me back',
};
const DeleteFeatureIssueScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const onPressBack = useCallback(() => {
        navigation.popToTop();
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT + rem(16), paddingHorizontalStyle);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <Animated.ScrollView onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} scrollEventThrottle={16} contentContainerStyle={paddingBottom}>
            <ScreenInfoHeader title={strings.deletingYourAccount} subTitle={strings.youMightLoseAccess} smallSubTitle/>
            <DeleteNeedAssitanceCard />
          </Animated.ScrollView>
          <ButtonGroup type="floating" margins>
            <Button title={strings.takeMeBack} brand onPress={onPressBack} testID="backButton"/>
          </ButtonGroup>
        </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default DeleteFeatureIssueScreen;
